import { ACCOUNT_ROUTE_NAME } from "@/libs/route-name";

export const aboutUsRoute = () => {
  return {
    name: ACCOUNT_ROUTE_NAME.ABOUT_US,
    path: "/about-us",
    component: () => import("@/pages/about-us/index.vue"),
    meta: {
      requireAuth: false
    }
  };
};
